import { render, staticRenderFns } from "./ButtonNormal.vue?vue&type=template&id=59ddf6c2&scoped=true&"
import script from "./ButtonNormal.vue?vue&type=script&lang=js&"
export * from "./ButtonNormal.vue?vue&type=script&lang=js&"
import style0 from "./ButtonNormal.vue?vue&type=style&index=0&id=59ddf6c2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ddf6c2",
  null
  
)

export default component.exports